<section class="tickets-toolbar">
  <div class="tickets-filter">
    <label for="periodo-ticket">Periodo</label>
    <div class="tickets-select">
      <mat-icon>date_range</mat-icon>
      <select id="periodo-ticket" [(ngModel)]="periodoSeleccionado" (ngModelChange)="aplicarPeriodo()">
        <option *ngFor="let periodo of periodos" [ngValue]="periodo.id">{{ periodo.nombre }}</option>
      </select>
    </div>
  </div>

  <div class="tickets-filter">
    <label for="fecha-inicio-ticket">Inicio</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="tickets-date-field">
      <input id="fecha-inicio-ticket" matInput aria-label="Inicio" [matDatepicker]="fechaInicioPicker" [(ngModel)]="fechaInicioSeleccionada"
        (dateChange)="onFechaInicioChange($event.value)" />
      <mat-datepicker-toggle matSuffix [for]="fechaInicioPicker"></mat-datepicker-toggle>
      <mat-datepicker #fechaInicioPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="tickets-filter">
    <label for="fecha-fin-ticket">Fin</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="tickets-date-field">
      <input id="fecha-fin-ticket" matInput aria-label="Fin" [matDatepicker]="fechaFinPicker" [(ngModel)]="fechaFinSeleccionada"
        (dateChange)="onFechaFinChange($event.value)" />
      <mat-datepicker-toggle matSuffix [for]="fechaFinPicker"></mat-datepicker-toggle>
      <mat-datepicker #fechaFinPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="tickets-toolbar__meta">
    <span>{{ totalTickets }} tickets</span>
    <strong>{{ getPeriodoLabel() }}</strong>
  </div>
</section>

<div class="tickets-alert" *ngIf="errorCarga">
  {{ errorCarga }}
</div>

<section class="tickets-kpis" aria-label="Indicadores principales de tickets">
  <article class="ticket-kpi" *ngFor="let kpi of kpis" [ngClass]="kpi.className">
    <div class="ticket-kpi__icon">
      <mat-icon>{{ kpi.icon }}</mat-icon>
    </div>
    <div>
      <span>{{ kpi.label }}</span>
      <strong>{{ kpi.value }}</strong>
      <small>{{ kpi.meta }}</small>
    </div>
  </article>

  <div class="tickets-loading-card" *ngIf="cargando && kpis.length === 0">
    Actualizando indicadores...
  </div>
</section>

<section class="tickets-grid">
  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Estado operativo</span>
        <h2>Distribucion por estatus</h2>
      </div>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalTickets }}</strong>
          <span>Total</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of estatusItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }}</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && estatusItems.length === 0">
      No hay tickets para el periodo seleccionado.
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Demanda</span>
        <h2>Tipo de solicitud</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="tipoSolicitudItems.length > 0; else emptyTiposTpl">
      <div class="tickets-bar" *ngFor="let item of tipoSolicitudItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre || 'Sin clasificar' }}</span>
          <strong>{{ getBarPercent(item) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getBarStyle(item, i)"></span>
        </div>
        <small>{{ item.valor }} tickets</small>
      </div>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Areas solicitantes</span>
        <h2>Mayor volumen</h2>
      </div>
    </div>

    <div class="tickets-area-list" *ngIf="areaItems.length > 0; else emptyAreasTpl">
      <div class="tickets-area" *ngFor="let item of areaItems; let i = index">
        <span class="tickets-area__rank">{{ i + 1 }}</span>
        <div>
          <strong>{{ item.nombre || 'Sin area' }}</strong>
          <small>{{ item.valor }} tickets</small>
        </div>
        <span class="tickets-area__percent">{{ getBarPercent(item) }}%</span>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Tiempos promedio</span>
        <h2>Ciclo de atencion</h2>
      </div>
    </div>

    <div class="tickets-timeline">
      <div class="tickets-time" *ngFor="let tiempo of tiempos">
        <span></span>
        <div>
          <strong>{{ tiempo.valor }}</strong>
          <p>{{ tiempo.label }}</p>
          <small>{{ tiempo.meta }}</small>
        </div>
      </div>
    </div>
  </article>
</section>

<section class="tickets-card tickets-card--table" *ngIf="canViewTicketsAdmin">
  <div class="tickets-card__header">
    <div>
      <span>Actividad reciente</span>
      <h2>Tickets activos y atendidos</h2>
    </div>
    <button type="button" class="tickets-link-button" (click)="abrirTickets()">Ver todos</button>
  </div>

  <div class="tickets-table-wrap" *ngIf="ticketsRecientes.length > 0; else emptyTicketsTpl">
    <table class="tickets-table">
      <thead>
        <tr>
          <th>Ticket</th>
          <th>Asunto</th>
          <th>Solicitante</th>
          <th>Area</th>
          <th>Prioridad</th>
          <th>Estatus</th>
          <th>Fecha</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ticket of ticketsRecientes">
          <td class="tickets-table__id">#{{ ticket.id_ticket }}</td>
          <td>{{ ticket.asunto }}</td>
          <td>{{ ticket.nombreSolicitante }}</td>
          <td>{{ ticket.areaSolicitante || ticket.areaResolutora || 'Sin area' }}</td>
          <td>
            <span class="ticket-priority" [ngClass]="getPriorityClass(ticket)">
              <span></span>
              {{ ticket.prioridad || 'N/D' }}
            </span>
          </td>
          <td>
            <span class="ticket-status" [ngClass]="getTicketEstatusClass(ticket)">
              {{ getTicketEstatusLabel(ticket) }}
            </span>
          </td>
          <td>{{ ticket.fechaSolicitud | date:'dd/MM/yyyy' }}</td>
          <td>
            <button type="button" class="tickets-table__action" (click)="abrirTicket(ticket)" aria-label="Abrir ticket">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<ng-template #emptyTiposTpl>
  <div class="tickets-empty">No hay distribucion por tipo para el periodo.</div>
</ng-template>

<ng-template #emptyAreasTpl>
  <div class="tickets-empty">No hay distribucion por area para el periodo.</div>
</ng-template>

<ng-template #emptyTicketsTpl>
  <div class="tickets-empty">No hay tickets recientes para mostrar.</div>
</ng-template>
